<template>
	<div>
		<!-- Account page navigation-->
		<nav class="nav nav-borders justify-content-between justify-content-sm-start">
			<router-link :to="{ name: 'profile', params: {} }" class="nav-link">Профиль</router-link>
			<router-link :to="{ name: 'my-events', params: {} }" class="nav-link">Мои cобытия</router-link>
		</nav>
		<hr class="mt-0 mb-4" />
	</div>
</template>

<script>
export default {
	// mounted() {
	// 	document.body.classList.add("profile");
	// },
	// destroyed() {
	// 	document.body.classList.remove("profile");
	// },
	name: "profile-nav",
};
</script>

<style scoped>
.nav-borders .nav-link.active {
	color: #0061f2;
	border-bottom-color: #0061f2;
}
.nav-borders .nav-link {
	color: #69707a;
	border-bottom-width: 0.125rem;
	border-bottom-style: solid;
	border-bottom-color: transparent;
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	padding-left: 0;
	padding-right: 0;
	margin-left: 1rem;
	margin-right: 1rem;
}
</style>
